import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { HelmetProvider } from 'react-helmet-async'
import App from 'app/app'
import { AuthGate } from 'shared/auth/AuthGate'
import { Provider } from 'jotai'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
// i18next をグローバルに初期化する（副作用 import）。描画前に必ず 1 回だけ通す。
import { applyBrowserLocale } from 'shared/i18n'

applyBrowserLocale()

const container = document.getElementById('root')
if (container === null) {
  // index.html に #root が無いのはビルド構成の誤り。描画先が無いまま進めず、原因が分かる形で止める
  throw new Error('#root element not found')
}
const root = ReactDOM.createRoot(container)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

root.render(
  <Provider>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <BrowserRouter>
          <Suspense fallback={<div>Loading...</div>}>
            <AuthGate>
              <App />
            </AuthGate>
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
    </QueryClientProvider>
  </Provider>
)
